import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GenerateRandom } from "src/utils/random";
import { KeeniconComponent } from "../keenicon/keenicon.component";

@Component({
  selector: "app-filter-search-input",
  templateUrl: "./filter-search-input.component.html",
  styleUrls: ["./filter-search-input.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterSearchInputComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, TranslateModule, KeeniconComponent],
})
export class FilterSearchInputComponent implements ControlValueAccessor {
  @Input() label = "";
  @Input() placeholder = "";
  @Input() inputClass = "";
  @Input() classes = "";
  @Input() name = GenerateRandom(6);
  @Input() ariaLabel = "ค้นหา";

  @Output() searchSubmit = new EventEmitter<string>();

  value = "";
  isDisabled = false;

  writeValue(value: string | null): void {
    this.value = value ?? "";
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }

  onSearch(event?: Event): void {
    event?.preventDefault();
    this.searchSubmit.emit(this.value);
  }

  onClear(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.isDisabled || this.value === "") {
      return;
    }

    this.value = "";
    this.onChange(this.value);
    this.onTouched();
    this.searchSubmit.emit(this.value);
  }

  private onChange = (_value: string) => {};
  private onTouched = () => {};
}
